import { render, staticRenderFns } from "./Politica.vue?vue&type=template&id=04663280&scoped=true"
import script from "./Politica.vue?vue&type=script&lang=js"
export * from "./Politica.vue?vue&type=script&lang=js"
import style0 from "./Politica.vue?vue&type=style&index=0&id=04663280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04663280",
  null
  
)

export default component.exports